/****************************************************
 * Module Name:  EditCustomerDetailsModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import Select from "react-select";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import "bootstrap/dist/css/bootstrap.min.css";
import DesignationProxy from "../../utility/proxy/manager/designationProxy";
import { Avatar, Badge, Box, Button, Checkbox, Fade, FormControlLabel, IconButton, Menu, MenuItem, TextField, Tooltip, Typography, Switch } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import EmployeeProxy from "../../utility/proxy/manager/employeeProxy";
import { LoadingButton } from "@mui/lab";
import logo from "../../images/pansuriya.jpg";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import DocumentTyeProxy from "../../utility/proxy/manager/documentTypeProxy";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { CloseSharp } from "@mui/icons-material";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ListItemIcon from "@mui/material/ListItemIcon";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import UserProfileProxy from "../../utility/proxy/manager/userProfileProxy";
import UserProxy from "../../utility/proxy/manager/userProxy";
import { CitySelect, CountrySelect, StateSelect, GetCountries, GetState, GetCity, } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import SettingsProxy from "../../utility/proxy/manager/settingsProxy";
import UserPermissionProxy from "../../utility/proxy/manager/permissionProxy/userPermissionProxy";
import { styled } from "@mui/material/styles";

const KycSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

export default class EditCustomerDetailsModal extends Component {
    constructor(props) {
        super(props);

        this.fileInputRef = React.createRef();

        this.state = {

            userid: this.props.editOperation
                ? this.props.sourceData.id
                : "",

            newphoto: this.props.editOperation
                ? this.props.sourceData.photo
                : "",
            newcompanyname: this.props.editOperation
                ? this.props.sourceData.companyname
                : "",
            newusername: this.props.editOperation
                ? this.props.sourceData.username
                : "",
            newUserType:
                this.props.sourceData !== undefined
                    ? this.props.editOperation ||
                        (!this.props.editOperation && this.props.sourceData.usertype)
                        ? {
                            value: this.props.sourceData.usertype,
                            label: this.props.sourceData.usertype,
                        }
                        : { value: 0, label: "Error" }
                    : { value: 0, label: "Error" },
            initialStoneType: [],
            newStoneType: [],
            newfirst_name: this.props.editOperation
                ? this.props.sourceData.first_name
                : "",
            newmiddle_name: this.props.editOperation
                ? this.props.sourceData.middle_name
                : "",
            newlast_name: this.props.editOperation
                ? this.props.sourceData.last_name
                : "",
            newemail_id: this.props.editOperation
                ? this.props.sourceData.email
                : "",
            newphonecode: this.props.editOperation
                ? this.props.sourceData.phonecode
                : "",
            newphone_no: this.props.editOperation
                ? this.props.sourceData.phone
                : "",
            newaddress1: this.props.editOperation
                ? this.props.sourceData.address
                : "",
            newaddress2: this.props.editOperation
                ? this.props.sourceData.address2
                : "",
            newpincode: this.props.editOperation
                ? this.props.sourceData.pincode
                : "",
            newfax: this.props.editOperation
                ? this.props.sourceData.fax
                : "",
            newDiscount: this.props.editOperation
                ? this.props.sourceData.discount
                    ? this.props.sourceData.discount
                    : "0.0"
                : "0.0",
            newCommission: this.props.editOperation
                ? this.props.sourceData.commission
                    ? this.props.sourceData.commission
                    : "0.0"
                : "0.0",
            newLabGrownDiscount: this.props.editOperation
                ? this.props.sourceData.labgrowndiscount
                    ? this.props.sourceData.labgrowndiscount
                    : "0.0"
                : "0.0",
            newLabGrownCommission: this.props.editOperation
                ? this.props.sourceData.labgrowncommission
                    ? this.props.sourceData.labgrowncommission
                    : "0.0"
                : "0.0",
            newgstno: this.props.editOperation
                ? this.props.sourceData.gstinno
                : "",
            newpanno: this.props.editOperation
                ? this.props.sourceData.panno
                : "",
            newemergencycontactname: this.props.editOperation
                ? this.props.sourceData.emergencycontactname
                : "",
            newemergencyphoneno: this.props.editOperation
                ? this.props.sourceData.emergencyphone
                : "",
            newemergencyaddress: this.props.editOperation
                ? this.props.sourceData.emergencyaddress
                : "",
            newlocation: this.props.editOperation
                ? this.props.sourceData.location
                : "",
            newGrade: this.props.editOperation
                ? {
                    value: this.props.sourceData.grade,
                    label: this.props.sourceData.grade,
                }
                : { value: 0, label: "Error" },
            newdesignation: this.props.editOperation
                ? this.props.sourceData.designation
                : "CUSTOMER",
            newlocationid: this.props.editOperation
                ? this.props.sourceData.locationid
                : "",
            newfullLocation: this.props.editOperation
                ? {
                    value: this.props.sourceData.locationid,
                    label: this.props.sourceData.location,
                }
                : { value: 0, label: "Error" },
            newdeleted: this.props.editOperation
                ? this.props.sourceData.deleted
                : false,
            newdisabled: this.props.editOperation
                ? this.props.sourceData.disabled
                : false,
            newkyc: this.props.editOperation
                ? this.props.sourceData.kyc
                : false,
            newspecialuser: this.props.editOperation
                ? this.props.sourceData.specialuser
                : false,
            newCreated: this.props.editOperation ? this.props.sourceData.created : "",
            newCreatedBy: this.props.editOperation ? this.props.sourceData.createdby : "",

            newtitle: this.props.editOperation
                ? this.props.sourceData.title
                : "",
            countryname: this.props.editOperation
                ? this.props.sourceData.country
                : "",
            statename: this.props.editOperation
                ? this.props.sourceData.state
                : "",
            cityname: this.props.editOperation
                ? this.props.sourceData.city
                : "",
            local_permission: this.props.editOperation
                ? this.props.permission
                : false,
            showError: false,

            validateUserPresentSpinner: false,
            showValidationMessage: false,
            userNameAvailable: true,
            isDesignationSetManually: false,

            fullLocation: [],
            fullLocationOptions: [],
            showLocationLoadSpinner: true,
            showCityStateCountryLoadSpinner: true,

            allUserType: [],
            allStoneType: [],
            allGrades: [],

            designationOptions: [],
            showDesignationLoadSpinner: true,

            profilePhoto: [],
            showProfilePhotoLoadSpinner: true,

            userNameValidationError: "",
            companyNameValidationError: "",
            firstNameValidationError: "",
            lastNameValidationError: "",
            phoneNoValidationError: "",
            phoneCodeValidationError: "",
            registerEmailValidationError: "",
            discountValidationError: "",
            labgrownDiscountValidationError: "",
            salutationValidationError: "",
            countryValidationError: "",
            discountPremiumLimit: "0.0",
            discountPremiumError: false,
            discountLimit: "0.0",
            discountError: "",
            labgrownDiscountError: "",

            maxCommission: "0.0",
            minCommission: "0.0",
            commissionError: "",
            labgrownCommissionError: "",
            commissionErrorMesssage: "",
            labgrownCommissionErrorMesssage: "",

            validateEmailPresentSpinner: false,
            showEmailValidationMessage: false,
            registerEmailAvailable: undefined,
            showDocTypeLoadSpinner: false,
            DocTypeOptions: [],
            selectedDocType: '',

            docTypeandFileName: [],
            discountTypes: "",

            settingKeys: [],

            changingPhoto: false,
            anchorEl: null,
            open: false,
            error: false,

            selectedCountry: "",
            selectedState: "",
            selectedCity: "",
            countryid: 0,
            stateid: 0,
            cityid: 0,
            titleOptions: Constants.TITLES,

            selectedTitle: "",
            warning: false,
            warningmessage: "",
            defaultCountryForPhoneCode: "",
            inputRef: React.createRef(),
        };

    }

    componentDidMount() {
        if (Object.keys(this.props.sourceData).length > 0) {
            this.getUserStoneTypePermission(this.props.sourceData.id);
        } else {
            this.setAllStoneType();
        }
        this.getAllLocationList(false);
        this.getAllDesignationList(false);
        this.getAllSettingKeys();
        if (this.props.sourceData === undefined) {
            this.getUserById();
        }
        this.getUserProfilePicture(false);
        this.getAllDocumentTypeList(false);
        this.getCountryStateCityData();
    }

    getUserStoneTypePermission = (userid) => {
        let userId = [userid];
        UserPermissionProxy.GetSingleUserStoneTypePermission(userId, (response) => {
            const permissionMap = new Map();
            response.forEach((perm) => {
                permissionMap.set(perm.permissionid, perm.permissionname);
            });

            const permissions = Array.from(permissionMap, ([permissionid, permissionname]) => ({
                value: permissionid,
                label: permissionname.replace("STONETYPE_", ""),
            }));

            this.setState({
                newStoneType: permissions,
                initialStoneType: permissions
            }, () => {
                this.setAllStoneType();
            });

        }
        );
    }

    getUserById = () => {
        EmployeeProxy.GetSingleEmployeeById(this.props.userId, (response) =>
            this.setState({
                newusername: response.username,
                newUserType: { value: response.usertype, label: response.usertype },
                newfirst_name: response.first_name,
                newmiddle_name: response.middle_name,
                newlast_name: response.last_name,
                newdesignation: response.designation,
                newemployeeid: response.employeeid,
                newlocationid: response.locationid,
                newfullLocation: {
                    value: response.locationid,
                    label: response.location + " | " + response.country,
                },
                newdeleted: response.deleted,
                newdisabled: response.disabled,
                newspecialuser: response.specialuser,
                newgrade: response.grade,

                newgstno: response.gstinno,
                newpanno: response.panno,
                newEmail: response.email,
                newPhone: response.phone,
                newCreated: response.created,
                newCreatedBy: response.createdby,
                newCompanyName: response.companyname,
            })
        );
    };

    handleClick = (event) => {
        this.setState({
            anchorEl: event.currentTarget,
            open: Boolean(event.currentTarget)
        })
    };

    handleMenuClose = (e) => {
        this.setState({
            anchorEl: null,
            open: false
        })
    };

    handleRemoveProfile = () => {
        this.setState({
            newphoto: null,
            anchorEl: null,
            changingPhoto: true,
            open: false,
        })
    };

    handleRemoveFile = (docType) => {
        const removeFileArray = this.state.docTypeandFileName;
        const indexToRemoveFile = this.state.docTypeandFileName.findIndex((item) => {
            return Object.keys(item)[0] === docType;
        })
        if (indexToRemoveFile !== -1) {
            if (removeFileArray[indexToRemoveFile] && removeFileArray[indexToRemoveFile].hasOwnProperty(docType)) {
                removeFileArray[indexToRemoveFile][docType] = null;
                removeFileArray[indexToRemoveFile]["fileByteArray"] = null;
            }
        }
        this.setState({
            docTypeandFileName: removeFileArray,
        })
    }

    getAllLocationList = (bAnimateSpinner) => {
        bAnimateSpinner && this.setState({ showLocationLoadSpinner: true });
        LocationProxy.GetAllLocationDetail((response) =>
            this.setAllLocationData(response)
        );
    };

    getUserProfilePicture = (bAnimateSpinner) => {
        if (this.state.userid) {
            bAnimateSpinner && this.setState({ showProfilePhotoLoadSpinner: true });
            UserProfileProxy.GetUserProfilePhotoByID(this.state.userid, (response) => {
                if (response) {
                    this.setState({
                        newphoto: response.photo,
                    })
                }
            });
        }
    };

    setAllLocationData = (response) => {
        this.setAllUserType();
        this.setAllGrades();
        this.setTitle();
        let cOptions = [];
        let nnewfullLocation = this.state.newfullLocation;
        response.map((data) => {
            let iOption = { value: data.id, label: data.name + " | " + data.country };
            cOptions.push(iOption);

            if (data.id === this.state.newfullLocation.value)
                nnewfullLocation = iOption;
            return true;
        });

        //During new creation option select first one as default
        if (nnewfullLocation.value === 0 && cOptions.length > 0)
            nnewfullLocation = cOptions[0];

        this.setState({
            fullLocation: response,
            fullLocationOptions: cOptions,
            newfullLocation: nnewfullLocation,
            showLocationLoadSpinner: false,
        });
    };

    validateUserPresent = (username) => {
        if (!username || username.trim() === "") return;

        this.setState({
            validateUserPresentSpinner: true,
        });

        if (this.props.sourceData.username !== username) {
            UserProxy.CheckUserNameAvailable(username, (response) => {
                //if we got response that means user is present at backend

                if (response) {
                    //Username already present
                    this.setState({
                        validateUserPresentSpinner: false,
                        userNameValidationError: "Username not available",
                        showValidationMessage: true,
                    });
                } else {
                    //Username not available, so can be used
                    this.setState({
                        validateUserPresentSpinner: false,
                        userNameValidationError: "Username available",
                        showValidationMessage: true,
                    });
                }
            });
        } else {
            this.setState({
                validateUserPresentSpinner: false,
                userNameValidationError: "",
                showValidationMessage: false,
            });
        }
    };

    setTitle = () => {

        let selectedtitle = "";
        if (this.state.newtitle) {
            this.state.titleOptions.forEach(idata => {
                if (idata.value.toLowerCase() === this.state.newtitle.toLowerCase()) {
                    selectedtitle = idata
                }
            })
        }
        if (selectedtitle) {
            this.setState({
                selectedTitle: selectedtitle,
            })
        } else {
            this.setState({
                selectedTitle: this.state.titleOptions[0],
            })
        }
    }

    setAllUserType = () => {
        let optionsArray = [];
        Object.keys(Constants.USER_TYPE).map((key) => {
            let option = { value: key, label: Constants.USER_TYPE[key] };
            optionsArray.push(option);
            return true;
        });

        // usertype by default to be customer as discussed with piyush
        let defaultOption = optionsArray.find((option) => option.value === "C");

        this.setState({
            allUserType: optionsArray,
            newUserType:
                this.state.newUserType.value === 0 && optionsArray.length > 0
                    ? defaultOption
                    : this.state.newUserType,
        });
    };

    setAllStoneType = () => {
        const filteredPermissions = Object.keys(Constants.PERMISSIONS)
            .filter((key) => key.startsWith("STONETYPE_"))
            .reduce((acc, key) => {
                acc[Constants.PERMISSIONS[key]] = key.replace("STONETYPE_", "");
                return acc;
            }, {});

        let optionsArray = [];
        Object.keys(filteredPermissions).map((key) => {
            let option = { value: parseInt(key), label: filteredPermissions[key] };
            optionsArray.push(option);
            return true;
        });

        const permissionIds = (this.state.newStoneType.length === 0) ? [] : this.state.newStoneType.map(item => item.value);
        const selectedOptions = optionsArray.filter(option => permissionIds.includes(option.value));
        const newStoneType = selectedOptions.length > 0 ? selectedOptions : !this.props.editOperation ? [optionsArray[0]] : [];

        this.setState({
            allStoneType: optionsArray,
            newStoneType,
        });

    };

    setAllGrades = () => {
        let optionsArray = [];
        Constants.GRADES.map((grade) => {
            let option = { value: grade, label: grade };
            optionsArray.push(option);
            return true;
        });
        this.setState({
            allGrades: optionsArray,
            newGrade:
                this.state.newGrade.value === 0 && optionsArray.length > 0
                    ? optionsArray[2]
                    : this.state.newGrade,
        });
    };

    getAllDesignationList = (bAnimateSpinner) => {
        bAnimateSpinner && this.setState({ showDesignationLoadSpinner: true });
        DesignationProxy.GetAllDesignation((response) =>
            this.setAllDesigationData(response)
        );
    };

    getAllSettingKeys = () => {
        let optionsArray = [];
        optionsArray.push("MAX_CUSTOMER_DISCOUNT");
        optionsArray.push("MAX_CUSTOMER_PREMIUM");
        optionsArray.push("MAX_BROKER_COMMISSION");
        optionsArray.push("MIN_BROKER_COMMISSION");

        SettingsProxy.GetSettingsByName(optionsArray, (response) =>
            this.setState({
                discountTypes: response,
                settingKeys: optionsArray,
            })
        );
    };

    setAllDesigationData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = { value: data.name, label: data.name };
            optionsArray.push(option);
            return true;
        });
        this.setState({
            designationOptions: optionsArray,
            newdesignation:
                this.state.newdesignation === "" && optionsArray.length > 0
                    ? optionsArray[0].value
                    : this.state.newdesignation,
            showDesignationLoadSpinner: false,
        });
    };

    getAllDocumentTypeList = (documentTypeSpinner) => {
        documentTypeSpinner && this.setState({ showDocTypeLoadSpinner: true });
        DocumentTyeProxy.getAllDocumentType((responseData) => {
            if (responseData) this.setAllDocumentTypeData(responseData)
            else {
                this.props.showSnackBar(Constants.APiFailErrorMessage, "error");
            }
        })
    }

    setAllDocumentTypeData = (res) => {
        if (res) {
            let optionsArray = [];
            let tempArray = [];
            res.map((data) => {
                let tempObj = {};
                let option = { value: data.id, label: data.type }
                optionsArray.push(option);
                tempObj[data.type] = null;
                tempArray.push(tempObj);
                return true;
            })
            this.setState({ DocTypeOptions: optionsArray, showDocTypeLoadSpinner: false, docTypeandFileName: tempArray })
        }
    }

    fileToByteArray = (file, callback) => {
        const reader = new FileReader();
        reader.onload = () => {
            const arrayBuffer = reader.result;
            const byteArray = new Uint8Array(arrayBuffer);
            callback(byteArray);
        };
        reader.onerror = (error) => {
            console.error('Error reading file:', error);
        };
        reader.readAsArrayBuffer(file); // Ensure this is correct
    };

    handleSave = () => {
        let profileData = new FormData();
        profileData.append("file", this.state.newphoto);

        if (this.state.userid) {
            if (this.state.changingPhoto) {
                if (this.state.newphoto === null) {
                    UserProfileProxy.RemoveProfilePhoto(
                        this.state.userid,
                        profileData,
                        (response) => this.updateProfile()
                    );
                } else {
                    UserProfileProxy.AddProfilePhoto(
                        this.state.userid,
                        profileData,
                        (response) => this.updateProfile()
                    );
                }
            } else {
                this.updateProfile();
            }
        } else {
            this.updateProfile();
        }

    };

    updateProfile = () => {
        let tempUserDocUploadArray = [];
        let dummyFunction = (item) => {
            let tempVariable = 0;
            this.state.DocTypeOptions.map((data) => {
                if (data.label === item) {
                    tempVariable = data.value;
                }
                return true;
            });
            return tempVariable;
        }

        this.state.docTypeandFileName.map((item) => {
            if (Object.values(item)[0] !== null) {
                let tempUserDocObj = {
                    docid: dummyFunction(Object.keys(item)[0]),
                    doctype: Object.keys(item)[0],
                    doc: Object.values(item)[1],
                    filename: Object.values(item)[0].name,
                    username: this.state.registerUserName ? this.state.registerUserName : '',
                }
                tempUserDocUploadArray.push(tempUserDocObj);
            }
            return true;
        });

        const stoneType = this.state.newStoneType;
        const initialStoneType = this.state.initialStoneType;
        let data = {
            id: this.props.editOperation ? this.props.sourceData.id : undefined,
            username: this.state.newusername,
            first_name: this.state.newfirst_name,
            middle_name: this.state.newmiddle_name,
            last_name: this.state.newlast_name,
            designation: this.state.newdesignation,
            specialuser: this.state.newspecialuser,
            locationid: this.state.newfullLocation.value,
            deleted: this.state.newdeleted,
            disabled: this.state.newdisabled,
            grade: this.state.newGrade.value,
            gstinno: this.state.newgstno,
            panno: this.state.newpanno,
            usertype: this.state.newUserType.value,
            email: this.state.newemail_id,
            phonecode: this.state.newphonecode,
            phone: this.state.newphone_no,
            created: this.state.newCreated,
            companyname: this.state.newcompanyname.trim(),
            createdby: this.props.editOperation ? this.state.newCreatedBy : Constants.loggedInUser.username,
            address: this.state.newaddress1,
            address2: this.state.newaddress2,
            emergencyaddress: this.state.newemergencyaddress,
            doc: tempUserDocUploadArray,
            city: this.state.cityname,
            state: this.state.statename,
            country: this.state.countryname,
            pincode: this.state.newpincode,
            fax: this.state.newfax,
            title: this.state.selectedTitle.value,
            emergencycontactname: this.state.newemergencycontactname,
            emergencyphone: this.state.newemergencyphoneno,
            discount: this.state.newDiscount,
            commission: this.state.newCommission,
            labgrowndiscount: this.state.newLabGrownDiscount,
            labgrowncommission: this.state.newLabGrownCommission,
            kyc: this.state.newkyc,
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data))
                    this.props.handleSave(data, stoneType, initialStoneType, this.state.newphoto);
                else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleSave(data, stoneType, initialStoneType, this.state.newphoto);
        }
    }

    handleRefClick = () => {
        this.fileInputRef.current.click();
    };

    handleRefClickPhoto = () => {
        // 👇️ open file input box on click of another element
        this.state.inputRef.current.click();
        this.setState({
            anchorEl: null,
            open: null,
        });
    };

    handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            let tempTypeandFile = this.state.docTypeandFileName;
            if (this.state.selectedDocType.label !== null) {
                tempTypeandFile.map((item) => {
                    if (item.hasOwnProperty(this.state.selectedDocType.label)) {
                        item[this.state.selectedDocType.label] = file;
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            const base64String = reader.result
                            const commaIndex = base64String.indexOf(',');
                            const base64WithoutPrefix = base64String.substring(commaIndex + 1)
                            item["fileByteArray"] = base64WithoutPrefix;
                        };
                        reader.readAsDataURL(file);
                    }
                    return true;
                })
            }
            this.setState({ docTypeandFileName: tempTypeandFile, selectedDocType: '' });
        }
    }

    getCountryStateCityData() {
        // Fetch all countries, and match saved values for prefill
        if (this.state.countryname && this.state.countryname !== "") {
            GetCountries().then((countries) => {
                const country = countries.find(
                    (c) => c.name.toLowerCase() === this.state.countryname.toLowerCase()
                );

                if (country) {
                    this.setState({ selectedCountry: country, countryid: country.id });
                    // Fetch states based on prefilled country
                    GetState(country.id).then((states) => {
                        const state = states.find((s) => {
                            return s.name && this.state.statename ? s.name.toLowerCase() === this.state.statename.toLowerCase() : false
                        });

                        if (state) {
                            this.setState({ selectedState: state, stateid: state.id });
                            // Fetch cities based on prefilled state
                            GetCity(country.id, state.id).then(
                                (cities) => {
                                    const city = cities.find((c) => c.name.toLowerCase() === this.state.cityname.toLowerCase());

                                    if (city) {
                                        this.setState({ selectedCity: city, cityid: city.id, });
                                    }
                                }
                            );
                        }
                    });

                    if (this.state.newphonecode && this.state.newphonecode !== String(country.phone_code)) {
                        this.fetchPhoneCode();
                    } else {
                        this.setState({ newphonecode: String(country.phone_code), defaultCountryForPhoneCode: String(country.iso2.toLowerCase()) });
                    }
                } else {
                    this.fetchPhoneCode();
                }
            });
        } else {
            this.fetchPhoneCode();
        }
    }

    fetchPhoneCode = () => {
        GetCountries().then((countries) => {
            const country1 = countries.find(
                (c) => String(c.phone_code) === this.state.newphonecode
            );
            if (!country1) {
                this.setState({ newphonecode: "", defaultCountryForPhoneCode: "in", })
            } else {
                this.setState({
                    newphonecode: String(country1.phone_code), defaultCountryForPhoneCode: String(country1.iso2.toLowerCase()),
                })
            }
        })
    }

    emailValidation = (e) => {

        let tEmail = e.target.value.replace(/\s/g, '').toLowerCase();

        this.setState({
            newemail_id: tEmail,
            showEmailValidationMessage: false,
        });

        if (this.props.sourceData.email !== e.target.value) {

            this.setState({
                registerEmailValidationError: Utility.CheckIsEmail(tEmail)
                    ? ""
                    : "Enter valid Email Id",
            });
            if (e.key === 'Enter' || e.type === 'blur') {
                if (Utility.CheckIsEmail(tEmail)) {
                    this.validateEmailPresent(tEmail);
                } else {
                    this.setState({
                        registerEmailValidationError: "Enter valid Email Id",
                    });
                }
            }
        } else {
            this.setState({
                registerEmailValidationError: "",
            });
        }
    }

    validateEmailPresent = (email) => {
        if (!email || email.trim() === "") return;

        this.setState({
            validateEmailPresentSpinner: true,
        });

        UserProxy.checkUserEmailAvailable(email, (response) => {
            //if we got response that means email is present at backend
            if (response) {
                //Email already present
                this.setState({
                    validateEmailPresentSpinner: false,
                    showEmailValidationMessage: true,
                    registerEmailAvailable: false,
                });
            } else {
                //Username not available, so can be used
                this.setState({
                    validateEmailPresentSpinner: false,
                    showEmailValidationMessage: true,
                    registerEmailAvailable: true,
                })
            }
        })
    }

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    userTypeChangeHandler = (selectedOption, type) => {
        const limits = {
            C: {
                MAX: "MAX_CUSTOMER_DISCOUNT",
                MIN: "MAX_CUSTOMER_PREMIUM",
            },
            B: {
                MAX: "MAX_BROKER_COMMISSION",
                MIN: "MIN_BROKER_COMMISSION",
            },
            CUSTOMER: {
                MAX: "MAX_CUSTOMER_DISCOUNT",
                MIN: "MAX_CUSTOMER_PREMIUM",
            },
            BROKER: {
                MAX: "MAX_BROKER_COMMISSION",
                MIN: "MIN_BROKER_COMMISSION",
            }
        };

        const { MAX, MIN } = limits[selectedOption.label] || {};

        let MIN_MAX_LIMIT = [];
        if (MAX && MIN && this.state.settingKeys.includes(MAX) && this.state.settingKeys.includes(MIN)) {
            MIN_MAX_LIMIT = this.state.discountTypes.filter(iTypes =>
                iTypes.settingkey === MAX || iTypes.settingkey === MIN
            );
        }

        const getLimitValue = (key) => {
            const limit = MIN_MAX_LIMIT.find(iTypes => iTypes.settingkey === key);
            return limit ? limit.settingvalue : "0.0";
        };

        const MAX_LIMIT_VALUE = getLimitValue(MAX);
        const MIN_LIMIT_VALUE = getLimitValue(MIN);

        const naturalCommonState = {
            newUserType: selectedOption,
            newCommission: "0.0",
            newDiscount: "0.0",
            discountValidationError: "",
            commissionError: ""
        };

        const labGrownCommonState = {
            newUserType: selectedOption,
            newLabGrownCommission: "0.0",
            newLabGrownDiscount: "0.0",
            labgrownDiscountValidationError: "",
            labgrownCommissionError: ""
        };

        if (selectedOption.label === "C" || selectedOption.label === "CUSTOMER") {
            if (type === "natural") {
                this.setState({
                    ...naturalCommonState,
                    discountPremiumLimit: MIN_LIMIT_VALUE,
                    discountLimit: MAX_LIMIT_VALUE,
                    discountPremiumError: `You can assign discount in the range of ${MAX_LIMIT_VALUE} to ${MIN_LIMIT_VALUE}`

                })
            } else if (type === "labgrown") {
                this.setState({
                    ...labGrownCommonState,
                    discountPremiumLimit: MIN_LIMIT_VALUE,
                    discountLimit: MAX_LIMIT_VALUE,
                    labgrownDiscountError: `You can assign discount in the range of ${MAX_LIMIT_VALUE} to ${MIN_LIMIT_VALUE}`
                })
            } else {
                this.setState({
                    newUserType: selectedOption,
                    newLabGrownCommission: "0.0",
                    labgrownCommissionError: "",
                    commissionError: "",
                    newCommission: "0.0",
                })
            }
        } else if (selectedOption.label === "B" || selectedOption.label === "BROKER") {
            if (type === "natural") {
                this.setState({
                    ...naturalCommonState,
                    minCommission: MIN_LIMIT_VALUE,
                    maxCommission: MAX_LIMIT_VALUE,
                    commissionErrorMesssage: `You can assign commission in the range of ${MIN_LIMIT_VALUE} to ${MAX_LIMIT_VALUE}`

                })
            } else if (type === "labgrown") {
                this.setState({
                    ...labGrownCommonState,
                    minCommission: MIN_LIMIT_VALUE,
                    maxCommission: MAX_LIMIT_VALUE,
                    labgrownCommissionErrorMesssage: `You can assign commission in the range of ${MIN_LIMIT_VALUE} to ${MAX_LIMIT_VALUE}`
                })
            } else {
                this.setState({
                    newUserType: selectedOption,
                    newDiscount: "0.0",
                    discountValidationError: "",
                    newLabGrownDiscount: "0.0",
                    labgrownDiscountValidationError: "",
                })
            }
        } else {
            if (type === "natural") {
                this.setState(naturalCommonState);
            } else if (type === "labgrown") {
                this.setState(labGrownCommonState);
            } else {
                this.setState({
                    newUserType: selectedOption,
                    newCommission: "0.0",
                    newDiscount: "0.0",
                    discountValidationError: "",
                    commissionError: "",
                    newLabGrownCommission: "0.0",
                    newLabGrownDiscount: "0.0",
                    labgrownDiscountValidationError: "",
                    labgrownCommissionError: ""
                })
            }
        }
    };

    setDiscountError = (e, type) => {
        if (
            !e.target.value.length ||
            e.target.value === undefined ||
            e.target.value === null
        ) {
            return "";
        }
        if (parseFloat(e.target.value) < this.state.discountLimit || parseFloat(e.target.value) > this.state.discountPremiumLimit) {

            if (type === "natural")
                return this.state.discountPremiumError;
            else if (type === "labgrown")
                return this.state.labgrownDiscountError;
            else
                return "";
        }

        return "";
    };

    setCommissionError = (e, type) => {
        if (
            !e.target.value.length ||
            e.target.value === undefined ||
            e.target.value === null
        ) {
            return "";
        }

        if (parseFloat(e.target.value) < this.state.minCommission || parseFloat(e.target.value) > this.state.maxCommission) {
            if (type === "natural")
                return this.state.commissionErrorMesssage;
            else if (type === "labgrown")
                return this.state.labgrownCommissionErrorMesssage;
            else
                return "";
        }
        return "";
    };



    buttonDisable = () => {
        const hasValidationErrors =
            !this.state.newcompanyname ||
            !this.state.newfirst_name ||
            !this.state.newlast_name ||
            !this.state.newemail_id ||
            !this.state.newphonecode ||
            !this.state.newphone_no ||
            !this.state.countryname ||
            !this.state.selectedTitle ||
            !this.state.newUserType.value ||
            this.state.companyNameValidationError ||
            this.state.firstNameValidationError ||
            this.state.lastNameValidationError ||
            this.state.phoneNoValidationError ||
            this.state.phoneCodeValidationError ||
            this.state.discountValidationError ||
            this.state.labgrownDiscountValidationError ||
            this.state.commissionError ||
            this.state.labgrownCommissionError ||
            this.state.salutationValidationError ||
            this.state.countryValidationError ||
            this.state.registerEmailValidationError ||
            (this.props.sourceData === undefined && this.state.userNameValidationError);

        return hasValidationErrors;
    };


    handlePhotoChange = (event) => {
        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
            return;
        }
        if (event.target.files[0].size > 1024000) {
            this.setState({
                error: false,
            });

        }
        this.setState({
            newphoto: event.target.files[0],
            changingPhoto: true,
        });

        // 👇️ reset file input
        event.target.value = null;
    };

    render() {
        return (
            <Box sx={{
                "& .MuiBox-root": {
                    marginRight: 0,
                    marginLeft: 0
                }
            }}>
                <input
                    type="file"
                    ref={this.state.inputRef}
                    onInputCapture={this.handlePhotoChange}
                    hidden
                    accept="image/*"
                />
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Edit cust/Emp validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />
                <CommonSnackbar
                    show={this.state.warning}
                    message={this.state.warningmessage}
                    variant={"warning"}
                    autoHide={Constants.SnackBarCloseTimer}
                    title={"Warning"}
                    handleClose={() => {
                        this.setState({
                            warning: false,
                            warningmessage: ""
                        })
                    }}
                />
                <Modal
                    show={this.props.Show}
                    onHide={this.props.handleClose}
                    dialogClassName="max-modalSize"
                    enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;Edit cust/Emp
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Box mb={2} ml={2} mr={3}
                            sx={{
                                width: "100%",
                                "& .css-2vawn2-MuiTypography-root": {
                                    alignSelf: "center",
                                },
                            }}
                        >
                            <Box
                                display={"flex"}
                                alignItems="center"
                                gap={'30px'}
                                marginTop={'20px'}
                                flexWrap="nowrap"
                            >

                                {/* Left Side: Photo and Edit Button */}
                                <Box width={"12%"} marginLeft={"3%"}>
                                    <Tooltip title="Change Photo">
                                        <IconButton
                                            onClick={this.handleClick}
                                            size="small"
                                            sx={{ ml: 2 }}
                                            aria-controls={this.state.open ? "account-menu" : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={this.state.open ? "true" : undefined}
                                        >
                                            <Badge
                                                overlap="circular"
                                                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                badgeContent={
                                                    <Avatar sx={{ width: 40, height: 40, opacity: 0.9 }}>
                                                        <EditRoundedIcon />
                                                    </Avatar>
                                                }
                                            >
                                                <Avatar
                                                    sx={{ width: 152, height: 152, fontSize: "6rem" }}
                                                    src={
                                                        this.state.changingPhoto && this.state.newphoto !== null
                                                            ? URL.createObjectURL(this.state.newphoto)
                                                            : `data:image/png;base64, ${this.state.newphoto}`
                                                    }
                                                >
                                                    {Constants.loggedInUser.username.substring(0, 1).toUpperCase()}
                                                </Avatar>
                                            </Badge>
                                        </IconButton>
                                    </Tooltip>
                                    <Typography
                                        variant="caption"
                                        display={this.state.error ? "flex" : "none"}
                                        justifyContent="center"
                                        color="red"
                                    >
                                        File size should be less than 1024kb
                                    </Typography>
                                    <Menu
                                        anchorEl={this.state.anchorEl}
                                        id="account-menu"
                                        open={this.state.open}
                                        TransitionComponent={Fade}
                                        onClose={this.handleMenuClose}
                                        onClick={this.handleMenuClose}
                                    >
                                        <MenuItem onClick={this.handleRefClickPhoto}>
                                            <ListItemIcon>
                                                <AddAPhotoIcon fontSize="small" />
                                            </ListItemIcon>
                                            upload photo
                                        </MenuItem>
                                        <MenuItem onClick={this.handleRemoveProfile}>
                                            <ListItemIcon>
                                                <DeleteRoundedIcon fontSize="small" />
                                            </ListItemIcon>
                                            Remove photo
                                        </MenuItem>
                                    </Menu>
                                </Box>

                                {/* Center: User Information */}
                                <Box width={"70%"}>
                                    {this.props.editOperation && (
                                        <Box sx={{ display: "flex", width: "100%", mb: 1 }}>
                                            <Typography sx={{ width: "10%" }}>User Id</Typography>
                                            <Typography sx={{ fontWeight: "600" }}>
                                                {this.props.sourceData.id}
                                            </Typography>
                                        </Box>
                                    )}
                                    {!this.props.sourceData && (
                                        <Box sx={{ display: "flex", width: "100%", mb: 1 }}>
                                            <Typography sx={{ width: "10%" }}>User Id</Typography>
                                            <Typography sx={{ fontWeight: "600" }}>
                                                {this.props.userId}
                                            </Typography>
                                        </Box>
                                    )}
                                    <Box sx={{ display: "flex", mt: 1 }}>
                                        <Typography sx={{ width: "10%" }}>Username</Typography>
                                        <Typography sx={{ fontWeight: "600" }}>
                                            {this.state.newusername}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", mt: 1 }}>
                                        <Typography sx={{ width: "10%", alignSelf: "center" }}>
                                            User Type
                                        </Typography>
                                        <Typography sx={{ fontWeight: "600" }}>
                                            {Constants.USER_TYPE[this.state.newUserType.value]}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", mt: 1, gap: "15px", mr: "26px", "& label": { marginBottom: 0 } }}>
                                        <Box>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={this.state.newdeleted}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                newdeleted: !this.state.newdeleted,
                                                            })
                                                        }
                                                        disabled={
                                                            !this.props.sourceData
                                                                ? this.props.userId === Constants.loggedInUser.id
                                                                : this.props.sourceData.id === Constants.loggedInUser.id ||

                                                                (this.state.local_permission.length === 0)}
                                                    />
                                                }
                                                label="Deleted"
                                                sx={{
                                                    "& .MuiFormControlLabel-label": {
                                                        fontSize: "0.8rem",
                                                    },
                                                }}
                                            />
                                        </Box>
                                        <Box>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={this.state.newdisabled}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                newdisabled: !this.state.newdisabled,
                                                            })
                                                        }
                                                        disabled={
                                                            !this.props.sourceData
                                                                ? this.props.userId === Constants.loggedInUser.id
                                                                : this.props.sourceData.id === Constants.loggedInUser.id ||

                                                                (this.state.local_permission.length === 0)}
                                                    />
                                                }
                                                label="Disabled"
                                                sx={{
                                                    "& .MuiFormControlLabel-label": {
                                                        fontSize: "0.8rem",
                                                    },
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            {/* Divide fields into 3 columns */}
                            <Box
                                display={"flex"}
                                alignItems="flex-start"
                                justifyContent="center"
                                gap={'30px'}
                                marginTop="20px"
                                flexWrap="wrap"
                            >
                                {/* First Column */}
                                <Box
                                    width="30%"
                                    display="flex"
                                    gap="16px"
                                    flexWrap="nowrap">
                                    <Box sx={{ width: "28%", "& .basic-single": { width: "100% !important" } }}>
                                        {/* Salutations Field */}
                                        <Typography sx={{ width: "100%" }}>
                                            Title <sup style={{ color: "red" }}>*</sup>
                                        </Typography>
                                        <Box sx={{ display: 'flex', marginTop: "1rem" }}>
                                            <Select
                                                menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                options={this.state.titleOptions}
                                                placeholder="Title"
                                                value={this.state.selectedTitle}
                                                onChange={(selectedOption) => {
                                                    this.setState({
                                                        selectedTitle: selectedOption,
                                                        salutationValidationError: Utility.CheckIsPresent(selectedOption.value)
                                                            ? ""
                                                            : "Salutations Cannot be Empty",
                                                    })
                                                }}
                                                menuPortalTarget={document.body}
                                                styles={Constants.Styles}
                                            />
                                        </Box>
                                        {this.state.salutationValidationError && (
                                            <Typography color="error">{this.state.salutationValidationError}</Typography>
                                        )}
                                    </Box>
                                    <Box width="69%">
                                        {/* First Name Field */}
                                        <Typography sx={{ width: "100%" }}>
                                            First Name <sup style={{ color: "red" }}>*</sup>
                                        </Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter First Name"
                                            value={this.state.newfirst_name}
                                            onChange={(e) =>
                                                this.setState({
                                                    newfirst_name: e.target.value.trim(),
                                                    firstNameValidationError: Utility.CheckIsPresent(e.target.value)
                                                        ? ""
                                                        : "First Name Cannot be Empty",
                                                })
                                            }
                                            helperText={this.state.firstNameValidationError}
                                            error={this.state.firstNameValidationError.length > 0}
                                        />
                                    </Box>
                                </Box>


                                <Box width={"30%"} display="flex" gap="16px" flexWrap="nowrap">
                                    {/* Second Column */}
                                    <Box width={"50%"}>
                                        <Typography sx={{ width: "100%" }}>Middle Name</Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter Middle Name"
                                            value={this.state.newmiddle_name}
                                            onChange={(e) =>
                                                this.setState({ newmiddle_name: e.target.value.trim() })
                                            }
                                        />
                                    </Box>
                                    {/* Third Column */}
                                    <Box width={"50%"}>
                                        <Typography sx={{ width: "100%" }}>Last Name <sup style={{ color: "red" }}>*</sup></Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter Last Name"
                                            value={this.state.newlast_name}
                                            onChange={(e) =>
                                                this.setState({
                                                    newlast_name: e.target.value.trim(),
                                                    lastNameValidationError: Utility.CheckIsPresent(e.target.value)
                                                        ? ""
                                                        : "Last Name Cannot be Empty ",
                                                })
                                            }
                                            helperText={this.state.lastNameValidationError}
                                            error={this.state.lastNameValidationError.length > 0}
                                        />
                                    </Box>
                                </Box>

                                {/* Company Name */}
                                <Box width={"30%"} display="flex" gap="16px" flexWrap="nowrap">
                                    <Box width="50%" >
                                        <Typography sx={{ width: "100%" }}>
                                            User Name <sup style={{ color: "red" }}>*</sup>
                                        </Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter user Name"
                                            value={this.state.newusername}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    this.validateUserPresent(e.target.value)
                                                }
                                            }}
                                            onBlur={(e) =>
                                                this.validateUserPresent(e.target.value)
                                            }
                                            onChange={(e) =>
                                                this.setState({
                                                    newusername: e.target.value.trim(),
                                                    userNameValidationError: Utility.CheckIsPresent(e.target.value)
                                                        ? ""
                                                        : "User Name Cannot be Empty ",
                                                })
                                            }
                                            disabled={this.props.sourceData.id === Constants.loggedInUser.id}
                                        />
                                        {this.state.validateUserPresentSpinner ? (
                                            <CircularProgress size="1rem" />
                                        ) : this.state.showValidationMessage ? (
                                            <div>
                                                <font style={{
                                                    fontSize: "14px", fontWeight: "500", color: this.state.userNameValidationError === "Username available" ? "#4EC073" : "red"
                                                }}>{this.state.userNameValidationError}</font></div>

                                        ) : null}

                                    </Box>
                                    <Box width="50%" >
                                        <Typography sx={{ width: "100%" }}>
                                            Company Name <sup style={{ color: "red" }}>*</sup>
                                        </Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter Company Name"
                                            value={this.state.newcompanyname}
                                            onChange={(e) =>
                                                this.setState({
                                                    newcompanyname: e.target.value,
                                                    companyNameValidationError: Utility.CheckIsPresent(e.target.value)
                                                        ? ""
                                                        : "Company Name Cannot be Empty ",
                                                })
                                            }
                                            helperText={this.state.companyNameValidationError}
                                            error={this.state.companyNameValidationError.length > 0}
                                        />
                                    </Box>
                                </Box>
                            </Box>

                            {/* Second Row for Last Name and More */}
                            <Box
                                display={"flex"}
                                alignItems="flex-start"
                                justifyContent={"center"}
                                gap={'30px'}
                                marginTop={'20px'}
                                flexWrap="wrap"
                            >
                                {/* Email Field */}
                                <Box width={"30%"}>
                                    <Typography sx={{ width: "100%" }}>
                                        Email Id <sup style={{ color: "red" }}>*</sup>
                                    </Typography>
                                    <TextField
                                        margin="normal"
                                        size="small"
                                        fullWidth
                                        placeholder="Enter Email Id"
                                        value={this.state.newemail_id}
                                        onChange={(e) => this.emailValidation(e)}
                                        onBlur={(e) => { this.emailValidation(e) }}
                                        onKeyDown={(e) => { this.emailValidation(e) }}
                                        helperText={this.state.registerEmailValidationError}
                                        error={this.state.registerEmailValidationError.length > 0}
                                    />
                                    {this.state.validateEmailPresentSpinner ? (
                                        <CircularProgress size="1rem" />
                                    ) : !this.state.showEmailValidationMessage ? (
                                        <div />
                                    ) : this.state.registerEmailAvailable !== undefined && (this.state.registerEmailAvailable ? (
                                        <font style={{ fontSize: "14px", fontWeight: "500", color: "#4EC073" }}>Email available</font>
                                    ) : (
                                        <font style={{ fontSize: "14px", fontWeight: "500", color: "red" }}>Email not available</font>
                                    ))}

                                </Box>

                                <Box width={"30%"} display="flex" gap="16px" flexWrap="nowrap">

                                    <Box width="50%" >
                                        <Typography sx={{ width: "100%" }}>Discount (%)</Typography>
                                        <TextField
                                            fullWidth
                                            margin="normal"
                                            size="small"
                                            type="number"
                                            label="Discount (%)"
                                            placeholder="Enter Discount"
                                            value={this.state.newDiscount}
                                            onChange={(e) => {
                                                this.userTypeChangeHandler(this.state.newUserType, "natural");
                                                this.setState({
                                                    newDiscount: e.target.value,
                                                    discountValidationError: this.setDiscountError(e, "natural"),
                                                });
                                            }}
                                            helperText={this.state.discountValidationError}
                                            error={this.state.discountValidationError.length > 0}
                                            disabled={this.state.local_permission.length === 0 || this.state.newUserType.value === "E" || this.state.newUserType.value === "B"}
                                        />
                                    </Box>
                                    <Box width="50%" >
                                        <Typography sx={{ width: "100%" }}>Commission (%)</Typography>
                                        <TextField
                                            fullWidth
                                            margin="normal"
                                            size="small"
                                            type="number"
                                            label="Commission"
                                            placeholder="Enter Commission"
                                            value={this.state.newCommission}
                                            onChange={(e) => {
                                                this.userTypeChangeHandler(this.state.newUserType, "natural");
                                                this.setState({
                                                    newCommission: e.target.value,
                                                    commissionError: this.setCommissionError(e, "natural")
                                                });
                                            }}
                                            helperText={this.state.commissionError}
                                            error={this.state.commissionError.length > 0}
                                            disabled={this.state.local_permission.length === 0 || this.state.newUserType.value === "E" || this.state.newUserType.value === "C"}
                                        />
                                    </Box>
                                </Box>
                                {/* lab grown broker commission & discount*/}
                                <Box width={"30%"} display="flex" gap="16px" flexWrap="nowrap">

                                    <Box width="50%" >
                                        <Typography sx={{ width: "100%" }}>Lab Grown Discount (%)</Typography>
                                        <TextField
                                            fullWidth
                                            margin="normal"
                                            size="small"
                                            type="number"
                                            label="LabGrown Discount (%)"
                                            placeholder="Enter Lab Grown Discount"
                                            value={this.state.newLabGrownDiscount}
                                            onChange={(e) => {
                                                this.userTypeChangeHandler(this.state.newUserType, "labgrown");
                                                this.setState({
                                                    newLabGrownDiscount: e.target.value,
                                                    labgrownDiscountValidationError: this.setDiscountError(e, "labgrown"),
                                                });
                                            }}
                                            helperText={this.state.labgrownDiscountValidationError}
                                            error={this.state.labgrownDiscountValidationError.length > 0}
                                            disabled={this.state.local_permission.length === 0 || this.state.newUserType.value === "E" || this.state.newUserType.value === "B"}
                                        />
                                    </Box>
                                    <Box width="50%" >
                                        <Typography sx={{ width: "100%" }}> Lab Grown Commission (%)</Typography>
                                        <TextField
                                            fullWidth
                                            margin="normal"
                                            size="small"
                                            type="number"
                                            label="LabGrown Commission(%)"
                                            placeholder="Enter Lab Grown Commission"
                                            value={this.state.newLabGrownCommission}
                                            onChange={(e) => {
                                                this.userTypeChangeHandler(this.state.newUserType, "labgrown");
                                                this.setState({
                                                    newLabGrownCommission: e.target.value,
                                                    labgrownCommissionError: this.setCommissionError(e, "labgrown")
                                                });
                                            }}
                                            helperText={this.state.labgrownCommissionError}
                                            error={this.state.labgrownCommissionError.length > 0}
                                            disabled={this.state.local_permission.length === 0 || this.state.newUserType.value === "E" || this.state.newUserType.value === "C"}
                                        />
                                    </Box>
                                </Box>
                            </Box>

                            <Box
                                display="flex"
                                alignItems="flex-start"
                                justifyContent="center"
                                gap="30px"
                                marginTop="20px"
                                flexWrap="wrap"
                            >
                                {/* Column 1: Address Line 1 */}

                                <Box width={"30%"} display="flex" gap="16px" flexWrap="nowrap">
                                    {/* Country Code Dropdown */}
                                    <Box width="23%"
                                        sx={{

                                            "&  .react-tel-input .form-control": {
                                                width: "106px !important",
                                                padding: "10.5px 10px 10.5px 58px !important",
                                                height: "40px !important",
                                            },
                                            "& .react-tel-input .country-list .search-box": {
                                                width: "90%  !important",
                                                padding: "10px 12px  !important",
                                                fontSize: "18px  !important",
                                            }
                                        }}
                                    >
                                        <Typography sx={{ width: "100%" }}>Country Code <sup style={{ color: "red" }}>*</sup> </Typography>
                                        <Box

                                            sx={{ marginTop: "1rem" }}>

                                            <PhoneInput
                                                key={this.state.newphonecode}
                                                country={this.state.defaultCountryForPhoneCode}
                                                enableSearch={true}
                                                value={this.state.newphonecode}
                                                defaultValue={this.state.newphonecode}
                                                onChange={(phonecode) => {
                                                    this.setState({
                                                        newphonecode: phonecode,
                                                        phoneCodeValidationError: Utility.CheckIsPresent(phonecode)
                                                            ? ""
                                                            : "Phone code cannot be empty",
                                                    })

                                                }}
                                                inputProps={{
                                                    placeholder: "",
                                                    readOnly: true,
                                                }}

                                            />
                                        </Box>
                                    </Box>

                                    {/* Phone No */}
                                    <Box width="75%">
                                        <Typography sx={{ width: "100%" }}>
                                            Phone No <sup style={{ color: "red" }}>*</sup>
                                        </Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter Phone No"
                                            value={this.state.newphone_no}
                                            type="number"
                                            onChange={(e) => {
                                                this.setState({
                                                    newphone_no: e.target.value.trim(),
                                                    phoneNoValidationError: Utility.CheckIsPresent(e.target.value)
                                                        ? "" : "Phone No cannot be empty",
                                                })
                                            }
                                            }
                                            helperText={this.state.phoneNoValidationError || this.state.phoneCodeValidationError}
                                            error={this.state.phoneNoValidationError.length > 0 || this.state.phoneCodeValidationError.length > 0}
                                        />
                                    </Box>
                                </Box>

                                <Box
                                    width="30%"
                                    display="flex"
                                    gap="16px"
                                    flexWrap="wrap">
                                    <Box width="48%">
                                        <Typography sx={{ width: "100%" }}>Pincode</Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter Pincode"
                                            value={this.state.newpincode}
                                            onChange={(e) =>
                                                this.setState({ newpincode: e.target.value.trim() })
                                            }
                                        />
                                    </Box>

                                    <Box width="48%"
                                        sx={{
                                            "& input": {
                                                border: "none !important",
                                                padding: "2px !important"
                                            },
                                            "& input:focus": {
                                                outline: "none !important"
                                            },
                                            "& container": {
                                                height: "41px",
                                            },
                                        }}
                                    >
                                        <Typography sx={{ width: "100%" }}>Country <sup style={{ color: "red" }}>*</sup></Typography>
                                        <Box sx={{
                                            marginTop: "1rem",
                                            "& .stdropdown-container": {
                                                fontFamily: "'Twemoji Mozilla','Arial' !important"
                                            },
                                        }}>
                                            <CountrySelect
                                                key={this.state.countryid}
                                                margin="normal"
                                                size="small"
                                                fullWidth
                                                placeHolder="Select Country"
                                                value={this.state.countryid}
                                                defaultValue={this.state.selectedCountry}
                                                onChange={(e) => {
                                                    this.setState({
                                                        selectedCountry: e,
                                                        countryid: e.id,
                                                        countryname: e.name,
                                                        stateid: 0,
                                                        cityid: 0,
                                                        statename: "",
                                                        cityname: "",
                                                        selectedCity: "",
                                                        selectedState: "",
                                                        newphonecode: String(e.phone_code),
                                                        countryValidationError: "",
                                                        defaultCountryForPhoneCode: String(e.iso2.toLowerCase())
                                                    });

                                                }}
                                                onBlur={(e) => {
                                                    if (e.target.value === "") {
                                                        this.setState({
                                                            countryid: 0,
                                                            stateid: 0,
                                                            cityid: 0,
                                                            countryname: "",
                                                            statename: "",
                                                            cityname: "",
                                                            selectedCountry: "",
                                                            selectedCity: "",
                                                            selectedState: "",
                                                            countryValidationError: "Please select Country",
                                                        });
                                                    } else {
                                                        this.setState({
                                                            countryValidationError: ""
                                                        });
                                                    }
                                                }}

                                            />
                                            {this.state.countryValidationError && (
                                                <Typography color="error" variant="caption">{this.state.countryValidationError}</Typography>
                                            )}
                                        </Box>
                                    </Box>
                                </Box>
                                {/* Column 3: City and State */}
                                <Box
                                    width="30%"
                                    display="flex"
                                    gap="16px"
                                    flexWrap="wrap"
                                >
                                    <Box width="48%"
                                        sx={{
                                            "& input": {
                                                border: "none !important",
                                                padding: "2px !important"
                                            },
                                            "& input:focus": {
                                                outline: "none !important"
                                            },
                                            "& container": {
                                                height: "41px"
                                            },
                                        }}>
                                        <Typography sx={{ width: "100%" }}>State</Typography>
                                        <Box sx={{
                                            marginTop: "1rem",
                                            "& .stdropdown-container": {
                                                fontFamily: "'Twemoji Mozilla','Arial' !important"
                                            },
                                        }}>
                                            <StateSelect
                                                key={this.state.countryid}
                                                margin="normal"
                                                size="small"
                                                fullWidth
                                                countryid={this.state.countryid}
                                                defaultValue={this.state.selectedState}
                                                placeHolder="Select State"
                                                value={this.state.stateid || ''}
                                                onChange={(e) => {
                                                    this.setState({
                                                        selectedState: e,
                                                        stateid: e.id,
                                                        statename: e.name,
                                                        cityid: 0,
                                                        cityname: "",
                                                        selectedCity: "",
                                                    })
                                                }}
                                                onClick={(e) => {
                                                    if (this.state.countryid === 0) {
                                                        this.setState({
                                                            warning: true,
                                                            warningmessage: "Please Select Country First"
                                                        })
                                                    }
                                                }}
                                                onBlur={(e) => {
                                                    if (e.target.value.trim() === "") {

                                                        this.setState({
                                                            stateid: 0,
                                                            cityid: 0,
                                                            statename: "",
                                                            cityname: "",
                                                            selectedCity: "",
                                                            selectedState: "",
                                                        });
                                                    }
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                    <Box width="48%"
                                        sx={{
                                            "& input": {
                                                border: "none !important",
                                                padding: "2px !important"
                                            },
                                            "& input:focus": {
                                                outline: "none !important"
                                            },
                                            "& container": {
                                                height: "41px"
                                            },
                                        }}
                                    >
                                        <Typography sx={{ width: "100%" }}>City</Typography>
                                        <Box sx={{
                                            marginTop: "1rem",
                                            "& .stdropdown-container": {
                                                fontFamily: "'Twemoji Mozilla','Arial' !important"
                                            },
                                        }}>
                                            <CitySelect
                                                key={`${this.state.countryid}-${this.state.stateid}`}
                                                countryid={this.state.countryid}
                                                stateid={this.state.stateid}
                                                defaultValue={this.state.selectedCity}
                                                margin="normal"
                                                size="small"
                                                fullWidth
                                                placeHolder="Select City"
                                                value={this.state.cityid}
                                                onChange={(e) => {
                                                    this.setState({
                                                        selectedCity: e,
                                                        cityid: e.id,
                                                        cityname: e.name,
                                                    })
                                                }}
                                                onClick={(e) => {

                                                    if (this.state.countryid === 0) {
                                                        this.setState({
                                                            warning: true,
                                                            warningmessage: "Please Select Country First"
                                                        })
                                                    } else if (this.state.stateid === 0) {
                                                        this.setState({
                                                            warning: true,
                                                            warningmessage: "Please Select State First"
                                                        })
                                                    }
                                                }}
                                                onBlur={(e) => {
                                                    if (e.target.value.trim() === "") {
                                                        this.setState({
                                                            cityid: 0,
                                                            cityname: "",
                                                            selectedCity: "",
                                                        });
                                                    }
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            <Box
                                display="flex"
                                alignItems="flex-start"
                                justifyContent="center"
                                gap="30px"
                                marginTop="20px"
                                flexWrap="wrap"
                            >
                                {/* Column 2: Address Line 2 */}
                                <Box width="30%">
                                    <Typography sx={{ width: "100%" }}>Address Line 1</Typography>
                                    <TextField autoComplete="new-password"
                                        margin="normal"
                                        size="small"
                                        fullWidth
                                        placeholder="Enter Address"
                                        value={this.state.newaddress1}
                                        onChange={(e) => this.setState({ newaddress1: e.target.value })}
                                    />
                                </Box>

                                <Box
                                    width="30%"
                                    display="flex"
                                    gap="16px"
                                    flexWrap="wrap">

                                    <Box width="48%">
                                        <Typography sx={{ width: "30%" }}>PAN No.</Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter PAN No."
                                            value={this.state.newpanno}
                                            onChange={(e) =>
                                                this.setState({ newpanno: e.target.value.trim() })
                                            }
                                        />
                                    </Box>

                                    <Box width="48%" >
                                        <Typography sx={{ width: "30%" }}>GST No.</Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter GST No."
                                            value={this.state.newgstno}
                                            onChange={(e) =>
                                                this.setState({ newgstno: e.target.value.trim() })
                                            }
                                        />
                                    </Box>
                                </Box>
                                <Box
                                    width="30%"
                                    display="flex"
                                    gap="16px"
                                    flexWrap="wrap">

                                    <Box sx={{ width: "45%" }} >
                                        <Typography sx={{ width: "100%", alignSelf: "center" }}>
                                            Location
                                        </Typography>

                                        <Box sx={{ display: 'flex', marginTop: "1rem" }}>
                                            <Box sx={{ width: "90%", flexShrink: 0 }}>
                                                <Select
                                                    menuPlacement="auto"
                                                    blurInputOnSelect={false}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    value={this.state.newfullLocation}
                                                    isSearchable={true}
                                                    name="Location"
                                                    options={this.state.fullLocationOptions}
                                                    onChange={(selectedOption) =>
                                                        this.setState({ newfullLocation: selectedOption })
                                                    }
                                                    menuPortalTarget={document.body}
                                                    styles={Constants.Styles}
                                                    isDisabled={this.state.local_permission.length === 0}
                                                />
                                            </Box>

                                            <Box sx={{ ml: 1, width: "5%", marginTop: "5px" }}>
                                                {this.state.showLocationLoadSpinner ? (
                                                    <CircularProgress size="1em" />
                                                ) : (
                                                    <Tooltip title="Reload">
                                                        <RefreshOutlinedIcon
                                                            color="primary"
                                                            fontSize="medium"
                                                            onClick={() => this.getAllLocationList(true)}
                                                            sx={{ cursor: "pointer", }}
                                                        />
                                                    </Tooltip>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box sx={{ width: "45%", marginLeft: "16px" }} >
                                        <Typography sx={{ width: "100%" }}>Designation</Typography>
                                        <Box sx={{ display: "flex", marginTop: "1rem" }}>
                                            <Box sx={{ width: "90%", flexShrink: 0 }}>
                                                <Select
                                                    menuPlacement="auto"
                                                    blurInputOnSelect={false}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    value={this.state.designationOptions.find(
                                                        (iDesig) => iDesig.value === this.state.newdesignation
                                                    )}
                                                    isSearchable={true}
                                                    name="Designation"
                                                    menuPortalTarget={document.body}
                                                    styles={Constants.Styles}
                                                    options={this.state.designationOptions}
                                                    onChange={(selectedOption) =>
                                                        this.setState({
                                                            newdesignation: selectedOption.value,
                                                            isDesignationSetManually: true,
                                                        })
                                                    }
                                                    isDisabled={this.state.local_permission.length === 0}
                                                />
                                            </Box>
                                            <Box sx={{ ml: 1, width: "10%", marginTop: "5px" }}>
                                                {this.state.showDesignationLoadSpinner ? (
                                                    <CircularProgress size="1em" />
                                                ) : (
                                                    <Tooltip title="Reload">
                                                        <RefreshOutlinedIcon
                                                            color="primary"
                                                            fontSize="medium"
                                                            onClick={() => this.getAllDesignationList(true)}
                                                            sx={{ cursor: "pointer" }}
                                                        />
                                                    </Tooltip>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            <Box
                                display={"flex"}
                                alignItems="flex-start"
                                justifyContent="center"
                                gap={'30px'}
                                marginTop={'20px'}
                                flexWrap="wrap"
                            >
                                <Box width={"30%"} display="flex" gap="16px" flexWrap="nowrap">

                                    <Box width="50%">
                                        <Typography sx={{ width: "100%" }}>Address Line 2</Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter Address"
                                            value={this.state.newaddress2}
                                            onChange={(e) => this.setState({ newaddress2: e.target.value })}
                                        />
                                    </Box>

                                    <Box width="50%" >
                                        <Typography sx={{ width: "100%" }}>Emergency Address</Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            rows={3}
                                            placeholder="Enter Emergency Address"
                                            value={this.state.newemergencyaddress}
                                            onChange={(e) =>
                                                this.setState({ newemergencyaddress: e.target.value })
                                            }
                                        />
                                    </Box>
                                </Box>

                                <Box
                                    width="30%"
                                    display="flex"
                                    gap="16px"
                                    flexWrap="nowrap">
                                    <Box width={"50%"}>
                                        <Typography sx={{ width: "100%" }}>Emergency Contact Name</Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter Emergency Contact Name"
                                            value={this.state.newemergencycontactname}
                                            onChange={(e) =>
                                                this.setState({ newemergencycontactname: e.target.value.trim() })
                                            }
                                        />
                                    </Box>
                                    <Box width={"50%"}>
                                        <Typography sx={{ width: "100%" }}>Emergency Phone No.</Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter Emergency Phone No."
                                            type="number"
                                            value={this.state.newemergencyphoneno}
                                            onChange={(e) =>
                                                this.setState({ newemergencyphoneno: e.target.value.trim() })
                                            }
                                        />
                                    </Box>
                                </Box>

                                <Box
                                    width="30%"
                                    display="flex"
                                    gap="16px"
                                    flexWrap="nowrap">

                                    {/* Fax Field */}
                                    <Box width={"50%"}>
                                        <Typography sx={{ width: "100%" }}>Fax</Typography>
                                        <TextField
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeholder="Enter Fax"
                                            value={this.state.newfax}
                                            onChange={(e) =>
                                                this.setState({ newfax: e.target.value.trim() })
                                            }
                                        />
                                    </Box>

                                    <Box width={"50%"}>
                                        <Typography sx={{ width: "100%" }}>
                                            Grade
                                        </Typography>
                                        <Box sx={{ flexShrink: 0, marginTop: "1rem" }}>
                                            <Select menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                value={this.state.allGrades.find(
                                                    (grade) => grade.value === this.state.newGrade.value
                                                )}
                                                isSearchable={true}
                                                name="Grades"
                                                menuPortalTarget={document.body}
                                                styles={Constants.Styles}
                                                options={this.state.allGrades}
                                                onChange={(selectedOption) =>
                                                    this.setState({ newGrade: selectedOption })
                                                }
                                                isDisabled={
                                                    !this.props.sourceData
                                                        ? this.props.userId === Constants.loggedInUser.id
                                                        : this.props.sourceData.id === Constants.loggedInUser.id ||
                                                        (this.state.local_permission.length === 0)
                                                }
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            {/* //document */}
                            <Box
                                display={"flex"}
                                alignItems="flex-start"
                                gap={'30px'}
                                marginTop={'20px'}
                                flexWrap="wrap"
                                justifyContent="center"
                            >
                                <Box width={"30%"} display="flex" gap="16px" flexWrap="nowrap">
                                    <Box width="50%">
                                        <Typography sx={{ width: "100%" }}>
                                            User Type <sup style={{ color: "red" }}>*</sup>
                                        </Typography>
                                        <Box sx={{ flexWrap: "nowrap", marginTop: "1rem" }}>
                                            <Select menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                value={this.state.allUserType.find(
                                                    (userType) =>
                                                        userType.value === this.state.newUserType.value
                                                )}
                                                isSearchable={true}
                                                name="UserType"
                                                menuPortalTarget={document.body}
                                                styles={Constants.Styles}
                                                options={this.state.allUserType}
                                                onChange={(selectedOption) => {
                                                    if (selectedOption.value !== this.props.sourceData.usertype) {
                                                        this.setState({
                                                            showTypeMsg: true,
                                                            newdesignation: this.state.isDesignationSetManually === false ? this.state.designationOptions.find(
                                                                (iDesig) => iDesig.value.toLowerCase() === selectedOption.label.toLowerCase()
                                                            ).value : this.state.newdesignation,
                                                        })
                                                    } else {
                                                        this.setState({
                                                            showTypeMsg: false
                                                        })
                                                    }
                                                    this.userTypeChangeHandler(selectedOption, "")
                                                }
                                                }
                                                isDisabled={
                                                    !this.props.sourceData
                                                        ? this.props.userId === Constants.loggedInUser.id
                                                        : this.props.sourceData.id === Constants.loggedInUser.id ||

                                                        (this.state.local_permission.length === 0)
                                                }
                                            />
                                            {
                                                this.props.editOperation && this.state.showTypeMsg ?
                                                    <Typography color={'orangered'}>
                                                        Changing the user type will affect all of his connection
                                                    </Typography>
                                                    : this.state.newUserType.value === null
                                                        ? <span style={{ color: 'red' }}>Please Select User Type</span> : ""
                                            }
                                        </Box>
                                    </Box>
                                    <Box width="50%">
                                        <Typography sx={{ width: "100%" }}>
                                            Stone Type Permission
                                        </Typography>
                                        <Box sx={{ flexWrap: "nowrap", marginTop: "1rem" }}>
                                            <Select
                                                isMulti
                                                menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                value={this.state.newStoneType}
                                                name="StoneType"
                                                menuPortalTarget={document.body}
                                                styles={Constants.Styles}
                                                options={this.state.allStoneType}
                                                onChange={(selectedOption) => {
                                                    this.setState({ newStoneType: selectedOption })
                                                }
                                                }
                                                isDisabled={
                                                    !this.props.sourceData
                                                        ? this.props.userId === Constants.loggedInUser.id
                                                        : this.props.sourceData.id === Constants.loggedInUser.id ||

                                                        (this.state.local_permission.length === 0)
                                                }
                                            />
                                        </Box>
                                    </Box>

                                </Box>
                                <Box width={"30%"} >
                                    <Typography style={{ width: "100%" }}>Document Type</Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginTop: "1rem" }}>
                                        <Box sx={{ width: "55%", flexShrink: 0 }}>
                                            <Select
                                                menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="Select Document Type"
                                                menuPortalTarget={document.body}
                                                styles={Constants.Styles}
                                                value={this.state.selectedDocType}
                                                onChange={(type) => this.setState({ selectedDocType: type })}
                                                options={this.state.DocTypeOptions.filter((item) => {
                                                    return this.state.docTypeandFileName.some((type) => {
                                                        return type[item.label] === null;
                                                    });
                                                })}
                                            />
                                        </Box>
                                        <Box sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>
                                            {this.state.showDocTypeLoadSpinner ? (
                                                <CircularProgress size="1rem" />
                                            ) : (
                                                <Tooltip title="Reload Document Type List">
                                                    <RefreshOutlinedIcon
                                                        color="primary"
                                                        fontSize="medium"
                                                        onClick={() => this.getAllDocumentTypeList(true)}
                                                        sx={{ cursor: "pointer" }}
                                                    />
                                                </Tooltip>
                                            )}
                                        </Box>
                                        <Box width={'45%'}>
                                            <Typography style={{ width: "50%" }}></Typography>
                                            <input
                                                type="file"
                                                accept=".pdf, .jpg, .jpeg, .png, .bmp, .heif, .heic"
                                                ref={this.fileInputRef}
                                                style={{ display: 'none' }}
                                                onChange={(e) => this.handleFileChange(e)}
                                            />
                                            <Tooltip title="Add New Document">
                                                <Button
                                                    color="info"
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{ ml: "10px" }}
                                                    onClick={() => this.handleRefClick()}
                                                    startIcon={<AddBoxOutlinedIcon size="large" />}
                                                    disabled={this.state.DocTypeOptions.length === 0 || this.state.selectedDocType === ""}
                                                >
                                                    Document
                                                </Button>
                                            </Tooltip>
                                        </Box>
                                    </Box>

                                </Box>
                                <Box width={"30%"} style={{ display: "flex", alignItems: "flex-start" }}>
                                    <Box style={{ minWidth: "50%" }}>
                                        <Typography style={{ width: "100%" }}>
                                            Selected Files:
                                            {this.state.docTypeandFileName.map((item) => {
                                                const file = Object.values(item)[0];
                                                const docType = Object.keys(item)[0];
                                                return (
                                                    <div>
                                                        {file !== null ?
                                                            <Typography variant='body1'>
                                                                <span>{docType + " : " + file.name}</span>
                                                                <CloseSharp onClick={() => this.handleRemoveFile(docType)} />
                                                            </Typography> : null}
                                                    </div>
                                                )
                                            })}
                                        </Typography>
                                    </Box>
                                    <Box style={{ gap: "10px", display: "flex", alignItems: "center", marginLeft: "12px" }}>
                                        <FormControlLabel
                                            control={
                                                <KycSwitch
                                                    sx={{ m: 1 }}
                                                    checked={this.state.newkyc}
                                                    onChange={() => this.setState({ newkyc: !this.state.newkyc })}
                                                />
                                            }
                                            disabled={this.props.sourceData.id === Constants.loggedInUser.id}
                                            label="KYC"
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Modal.Body>
                    <Modal.Footer>
                        {this.props.saveButton ? (
                            <LoadingButton
                                variant="contained"
                                loading={this.props.loading}
                                onClick={() => this.handleSave()}
                                disabled={this.buttonDisable()}
                                sx={{ mr: 1 }}
                            >
                                Save
                            </LoadingButton>
                        ) : null}
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box >
        );
    }
}
